import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class AcceptCookieService {
  private cookieKey = 'cookieAccepted';

  constructor(
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  hasAccepted(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return this.cookieService.get(this.cookieKey) === 'true';
    }
    return false;
  }

  accept() {
    if (isPlatformBrowser(this.platformId)) {
      this.cookieService.set(this.cookieKey, 'true', 365, '/');
    }
  }
}
